import { type DescriptionDT, type ProjectDescription } from '../features/bids/bid.types'

export const transformDescription = (description: DescriptionDT): ProjectDescription => {
  return {
    general: {
      key: description.key,
      filename: description.filename,
      read: description?.read,
      write: description?.write,
    },
    beneficiary: description.beneficiary,
    detailed: description.detailed,
    features: description.features,
  }
}
